import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-questionary-save',
  templateUrl: './questionary-save.component.html',
  styleUrls: ['./questionary-save.component.css']
})
export class QuestionarySaveComponent implements OnInit {
    form: FormGroup;
    urlToSave = '';
    constructor(private fb: FormBuilder, private dialogRef: MatDialogRef<QuestionarySaveComponent>) {
        this.form = this.fb.group({
            email: new FormControl('', [Validators.required, Validators.email]),
            confirmemail: new FormControl('', [Validators.required, Validators.email])
        }, { validators: emailMatchValidator });
    }

    ngOnInit(): void {
        this.urlToSave = window.location.href;
  }
    //define the toogle property
    public toggle: boolean = false;

    //copy to clipboard text
    copytoclipboardtext = "Copy location link to clipboard ";

    //copy to clip
    copytoclipboard () {
        this.copytoclipboardtext = "You copied the link to clipboard";
        if (!this.toggle) this.toggle = !this.toggle;
    }

    //send email
    sendemail() { this.dialogRef.close({ email: this.form.controls['email'].value })}
}

//validator: email match
export const emailMatchValidator: ValidatorFn = (formGroup: FormGroup): ValidationErrors | null => {
    return formGroup.get('email').value === formGroup.get('confirmemail').value || !formGroup.get('email').value || !formGroup.get('confirmemail').value ?
        null : { 'emailMismatch': true };
}

 